<template>
  <b-modal :active.sync="isModalActive" :width="720" scroll="keep">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="false"></b-loading>
    <div class="rounded-lg shadow-xl bg-white overflow-hidden border border-gray-200 border-[#E4E6EB]">
      <!-- HEADER sin fondo gris -->
      <header class="flex justify-between items-start flex-wrap gap-2 text-sm font-medium text-gray-800 px-6 py-4 border-b border-[#E4E6EB] uppercase tracking-wide">
        <div class="flex-1 min-w-0">
          <h2 class="break-words whitespace-normal">
            <div><b>Configuración reporte detallado</b></div>
          </h2>
        </div>
        <div class="flex-shrink-0">
        </div>
      </header>

      <!-- BODY con fondo blanco liso -->
      <div class="px-6 py-5 space-y-4 bg-white">
        <h5 class="title is-5">{{ $t('pages') }}</h5>
        <p>Configuración personalizada de páginas</p>
        <b-collapse v-for="(item, idx) in configs.pages" :key="'page_'+idx"
          class="card"
          animation="slide"
          :aria-id="item.name"
          :open="false"
        >
          <template #trigger="props">
              <div
                  class="card-header" role="button"
                  :aria-controls="item.name"
                  :aria-expanded="props.open">
                  <p class="card-header-title">
                      {{ item.name }}
                  </p>
                  <a class="card-header-icon">
                    <b-icon pack="fas"
                        :icon="props.open ? 'chevron-down' : 'chevron-up'">
                    </b-icon>
                  </a>
              </div>
          </template>

          <div class="card-content">
            <div class="mb-4 flex flex-col">
              <div class="flex justify-between items-center w-full">
                <label class="mr-5 font-semibold">Mostrar avance de progreso de: </label>
                <b-select v-model="item.showGroupProgress" class="mr-4">
                    <option v-for="item in types" :key="item.value" :value="item.value">
                        {{ item.label }}
                    </option>
                </b-select>
              </div>
              <div>
                <p>Seleccione los grupos a mostrar</p>
                <treeselect v-model="item.customGroups" :multiple="true" :options="getFilteredGroups"
                    :disabled="item.showGroupProgress != 'custom'" :normalizer="treeselectNormalizer" :placeholder="$t('select_group_menu')" append-to-body
                />
              </div>
            </div>
          </div>
          <!-- <footer class="card-footer">
              <a class="card-footer-item">Save</a>
              <a class="card-footer-item">Edit</a>
              <a class="card-footer-item">Delete</a>
          </footer> -->
        </b-collapse>

        <h5 class="title is-5 mt-4">{{$t('sections')}}</h5>
        <p>Secciones apareceran en el reporte</p>

        <b-collapse v-for="(item, idx) in configs.sections" :key="idx"
          class="card"
          animation="slide"
          :aria-id="item.name"
          :open="false"
        >
          <template #trigger="props">
              <div
                  class="card-header"
                  role="button"
                  :aria-controls="item.name"
                  :aria-expanded="props.open">
                  <p class="card-header-title">
                      {{ item.name }}
                  </p>
                  <a class="card-header-icon">
                      <b-icon pack="fas"
                          :icon="props.open ? 'chevron-down' : 'chevron-up'">
                      </b-icon>
                  </a>
              </div>
          </template>

          <div class="card-content">
            <div class="mb-4 flex flex-col">
              <div class="flex justify-between items-center w-full">
                <label class="mr-4 font-semibold-x uppercase-x">
                    Mostar esta sección
                </label>
                <b-switch v-model="item.visible" :disabled="!item.isUserManaged" size="small"/>
              </div>

              <div v-if="item && 'isEditable' in item" class="flex flex-col w-full mt-2 mb-2">
                <p class="mb-2">Personalize el código y nombre si es necesario</p>
                <div class="flex justify-between items-center w-full space-x-4">
                  <div class="w-1/3">
                    <b-field :label="$t('code')"
                      :message="'Sin espacios'"
                      :label-position="'inside'">
                      <b-input v-model="item.code"
                        :maxlength="10"
                        :size="'is-small'"
                        has-counter
                        :disabled="item.code"
                      ></b-input>
                    </b-field>
                  </div>
                  <div class="w-2/3">
                    <b-field :label="$t('name')" :message="'Nombre descriptivo descriptivo de la sección'"
                      :label-position="'inside'"
                    >
                      <b-input v-model="item.name"
                        :size="'is-small'"
                        maxlength="25"
                        has-counter
                        :disabled="!item.visible"></b-input>
                    </b-field>
                  </div>
                </div>
              </div>

              <div v-if="item.hasAssociatedGroup" class="mt-2">
                <treeselect v-model="item.groupId" :options="getAvailableGroups(idx)"
                    :normalizer="treeselectNormalizer"
                    placeholder="Selecciona grupo asociado"
                    :disabled="!item.visible"
                    @input="val => onGroupSelect(idx, val)" />
              </div>

              <div class="flex justify-between items-center w-full mt-2">
                <p class="mr-4">
                    Cantidad de imagenes adicionales a mostrar
                </p>
                <b-numberinput v-model="item.numberOfExtraImages" min="0" max="10" icon-pack="fas"
                  :disabled="!item.visible"
                  size="is-small"
                >
                </b-numberinput>
              </div>

              <div class="flex justify-between items-center w-full mt-2">
                <span class="mr-4">
                    Permitir al usuario habilitar o deshabilitar esta sección
                </span>
                <b-switch v-model="item.canDisableSection" size="is-small" :disabled="!item.visible" />
              </div>

              <div class="flex justify-between items-center w-full mt-2" v-if="item && 'documentType' in item">
                <span class="mr-4">
                    Tipo de documento a mostrar como imagen principal
                </span>
                <b-select v-model="item.documentType" @input="(value) => { item.userCanDefineLegend = false; }">
                  <option v-for="item in optionsDocumentTypes" :key="item.value" :value="item.value">
                      {{ item.label }}
                  </option>
                </b-select>
              </div>

              <div class="flex justify-between items-center w-full mt-2" v-if="item && 'documentType' in item">
                <span class="mr-4">
                    Permitir al usuario definir leyendas del documento
                </span>
                <b-switch v-model="item.userCanDefineLegend" size="is-small" :disabled="!(item && 'documentType' in item)" />
              </div>
            </div>
          </div>
          <!-- <footer class="card-footer">
              <a class="card-footer-item">Save</a>
              <a class="card-footer-item">Edit</a>
              <a class="card-footer-item">Delete</a>
          </footer> -->
        </b-collapse>
      </div>

      <!-- FOOTER sin fondo gris, solo borde superior -->
      <footer class="px-6 py-4 border-t border-[#E4E6EB] bg-white">
        <div class="w-full flex justify-end space-x-2">
          <v-button v-if="!processingData" color="grey" icon="door-closed" @click="isModalActive = false">{{ $t('close') }}</v-button>
          <v-button v-if="!processingData" @click="submitConfig" icon="plus">{{ $t('save') }}</v-button>

            <v-button-processing v-if="processingData" />
        </div>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import axios from "axios";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: "activity-group-link-modal",

  components: {
    Multiselect,
    Treeselect
  },

  props: {
    projectId: { type: Number, required: true },
    entityType: { type: String, default: 'project' },
    activityGroups: { type: Array, default: () => [] },
  },

  data() {
    return {
      processingData: false,
      isModalActive: false,
      isLoading: false,

      types: [
          { value: 'parent', label: 'Grupos padres' },
          { value: 'children', label: 'Grupos hijos' },
          { value: 'custom', label: 'Personalizado' }
      ],

      optionsDocumentTypes: [
          // { value: 'document', label: 'Documento' },
          { value: 'drawing', label: 'Plano' },
          { value: 'activity_document', label: 'Documento de actividad' },
          { value: null, label: 'Ninguno' }
      ],

      configs: [],
      subactivities_progress_groups: false,
      isLoading: false,
      selectedType: 'parent',
      selectedReportGroupIds: [],

    }
  },

  computed: {
    getFilteredGroups() {
      function filterTree(nodes, type) {
          if (type === 'parent') {
              return nodes
                  .filter(node => !node.parent_id)
                  .map(node => ({
                      ...node,
                      children: undefined
                  }));
          } else if (type === 'children') {
              const flattenChildren = (arr) => {
                  let result = [];
                  arr.forEach(node => {
                      if (node.parent_id) {
                          result.push({ ...node, children: undefined });
                      }
                      if (node.children) {
                          result = result.concat(flattenChildren(node.children));
                      }
                  });
                  return result;
              };
              return flattenChildren(nodes);
          }
          return nodes;
      }

      return filterTree(this.activityGroups, this.selectedType);
    },

    hasDocumentType(item) {
      // puede reemplazar a (item && 'documentType' in item) que hace lo mismo si no funciona usar este propiedad computada
      return item && typeof item.documentType !== 'undefined';
    }
  },

  created() {
  },

  mounted() {

  },

  methods: {

  treeselectNormalizer(n) {
      return { id: n.id, label: n.label, children: n.children }
  },

  async submitConfig() {
    try {

      this.isLoading = true;
      // TODO: falta validacion de datos antes
      if ( await this.assignCustomCodes() ) {
        const sectionsReport = []
        // TODO: para hacerlo mas mantenible esto deberia hacerco como un merge con el template de secciones
        // Esto hacerlo talves en  el service, de esta forma si en algun momento las propiedades cambian no hay que cambiar el codigo aca
        // y prevaleceran de la plantilla y los que no se eliminan

        // 1. Obtener el ID máximo actual
        let maxId = Math.max(
          0,
          ...this.configs.sections
            .filter(item => item.id && item.id > 0)
            .map(item => item.id)
        );

        // 2. Asignar nuevos ID a los que no lo tienen
        this.configs.sections.forEach(item => {
          if (!item.id || item.id === 0) {
            maxId += 1;
            item.id = maxId;
          }
        });


        this.configs.sections.forEach(cfg => {
          let obj = {
            id: cfg.id,
            code: cfg.code,
            name: cfg.name,
            description: cfg.description || '',
            visible: cfg.visible,
            canDisableSection: cfg.canDisableSection || false,
            isUserManaged: cfg.isUserManaged,
            numberOfExtraImages: cfg.numberOfExtraImages || 0,
            groupId: cfg.groupId || null,
            hasAssociatedGroup: cfg.hasAssociatedGroup,
            documentType: cfg.documentType || null,
            userCanDefineLegend: cfg.userCanDefineLegend || false,
            isEditable: cfg.isEditable || true,
            type: cfg.type || 'section',
            customizationType: cfg.customizationType || 'user-editable',
          }

          sectionsReport.push(obj)
        })

        // TODO: mismo que secciones este caso es necesario crear un template de paginas si sera lo mismo
        const pagesReport = this.configs.pages.map(page => ({
          id: page.id,
          code: page.code,
          name: page.name,
          description: page.description || '',
          visible: page.visible,
          showGroupProgress: page.showGroupProgress || 'parent',
          customGroups: Array.isArray(page.customGroups) ? page.customGroups : [],
          isUserManaged: page.isUserManaged || false,
          isEditable: page.isEditable || false,
          type: page.customizationType || 'custom',
          customizationType: page.customizationType || 'admin-only',
        }));

        const activityGroupsConfig = {
          view: {
          },

          reports: {
            detailed: {
              pages: pagesReport,
              sections: sectionsReport,
            },
          }
        }

        await axios.post(`/api/v2/project/${this.projectId}/configs`, {
            activity_groups: activityGroupsConfig
        })

        this.$buefy.toast.open({ message: this.$t('save_successful'), type: 'is-success' })

        this.$emit('epc-success-save-config', {
            pages: pagesReport,
            sections: sectionsReport,
        });
      }

    } catch (e) {
      // console.error('Error saving config:', e);
        this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
    } finally {
      this.isLoading = false;
    }
  },

  async setSubactivitiesProgressGroups() {
      await axios.post("/api/v2/project/" + this.projectId + "/set-subactivities-progress-groups", {
          subactivities_progress_groups: this.subactivities_progress_groups
      });
  },

  getAvailableGroups(currentIdx) {
      const selectedIds = this.configs.sections
          .filter((item, idx) => idx !== currentIdx && item.groupId)
          .map(item => item.groupId);

      const currentSelectedId = this.configs.sections[currentIdx]?.groupId;

      const markDisabled = (nodes) => {
          return nodes.map(node => {
              const isCurrent = node.id === currentSelectedId;
              const disabled = !isCurrent && selectedIds.includes(node.id);
              const result = { id: node.id, label: node.label, disabled };
              if (node.children) {
                  result.children = markDisabled(node.children);
              }
              return result;
          });
      };

      return markDisabled(this.activityGroups);
  },

  forceconfigsUpdate() {
      this.configs.sections = [...this.configs.sections];
  },

  getGroupNameById(id) {
      const search = (nodes) => {
          for (const node of nodes) {
              if (node.id === id) return node.label;
              if (node.children) {
                  const found = search(node.children);
                  if (found) return found;
              }
          }
          return null;
      };
      return id ? search(this.activityGroups) : null;
  },

  onGroupSelect(idx, newGroupId) {
    this.configs.sections.forEach((item, i) => {
        if (i !== idx && item.groupId === newGroupId) {
            item.groupId = null;
        }
    });
    this.configs.sections[idx].groupId = newGroupId;
    this.forceconfigsUpdate();
  },

  async assignCustomCodes() {
    try {
      const prevAssignedIds = this.configs.sections
        .map(cfg => cfg.prevGroupId)
        .filter(id => !!id);

      const newAssignedIds = this.configs.sections
          .map(cfg => cfg.groupId)
          .filter(id => !!id);

      const customCodeArray = this.configs.sections
          .filter(cfg => cfg.groupId)
          .map(cfg => ({
              id: cfg.groupId,
              code_custom: cfg.code
          }));

      prevAssignedIds.forEach(id => {
          if (!newAssignedIds.includes(id)) {
              customCodeArray.push({
                  id,
                  code_custom: null
              });
          }
      });

      if (customCodeArray.length) {
        await axios.patch('/api/v2/activity-groups/assign-code-custom', customCodeArray)
      }

      return true;

    } catch (e) {
      console.error('Error assigning custom codes:', e);
      this.$buefy.toast.open({ message: this.$t('error_loading_data'), type: 'is-danger' })
      return false;
    }
  },


  show(data) {
    this.configs = data
    this.isModalActive = true;
  },

  hide() {
    this.configs = {}

    this.isModalActive = false;
  }
  }
};
</script>
<style scoped>
/* Oculta los botones para aumentar los inputs numéricos */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  /* display: none; <- Crashes Chrome on hover */
  -webkit-appearance: none;
  margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type="number"] {
  -moz-appearance: textfield; /* Firefox */
}
</style>
